import { css, useTheme } from "@emotion/react";
import omit from "lodash/fp/omit";
import { Fragment, useState } from "react";

import {
  Icon,
  useThemeProps,
  Box,
  TypographyBlock,
  Section,
  InlineList,
  Button,
  Heading,
  generateUniqueId,
} from "../../wsui/base";

export default function DefaultTextModule(props) {
  props = useThemeProps({
    props,
    name: "MunicipioDefaultTextModule",
  });
  let {
    // eslint-disable-next-line no-unused-vars
    title: ignoredTitle,
    titleIcon,
    titleIconProps,
    // eslint-disable-next-line no-unused-vars
    description,
    buttonProps = {},
    title,
    color,
    align,
    links,
    // expandable,
    headingVariant,
    headingId,
    ...restProps
  } = omit(["expandable"], props);
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const inlineListAlign =
    contentAlign === "left"
      ? "start"
      : contentAlign === "right"
        ? "end"
        : contentAlign === "center"
          ? "center"
          : undefined;
  const contentJustify =
    contentAlign === "right"
      ? "flex-end"
      : contentAlign === "center"
        ? "center"
        : "flex-start";

  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();

  let MaybeSection = title ? Section : Fragment;

  const [defaltHeadingId] = useState(
    () => `module-heading-${generateUniqueId()}`,
  );
  headingId = headingId || defaltHeadingId;

  return (
    <Box color={color || "transparent"} {...restProps}>
      {title && (
        <Heading
          variant={headingVariant}
          marginAfter
          id={headingId}
          css={css`
            display: flex;
            gap: 0.5em;
            align-items: start;
            justify-content: ${contentJustify};
          `}
          align={contentAlign}
        >
          {titleIcon && (
            <Icon
              name={titleIcon}
              css={css`
                align-self: center;
                flex: none;
              `}
              {...titleIconProps}
            />
          )}
          {title}
        </Heading>
      )}

      <TypographyBlock align={contentAlign}>
        <MaybeSection>{description}</MaybeSection>
      </TypographyBlock>
      <MaybeSection>
        {!!links?.length && (
          <InlineList
            align={inlineListAlign}
            css={css`
              margin-top: ${theme.getLength(5)};
            `}
          >
            {links.map(({ link, variant }, index) => (
              <Button
                key={index}
                {...link}
                variant={variant ?? "primary"}
                {...buttonProps}
              />
            ))}
          </InlineList>
        )}
      </MaybeSection>
    </Box>
  );
}
